import UltMeta, { Meta } from "@/meta/UltMeta/index";
import { THEME_COLOR } from "@/meta/common";

/**
 * 申领状态
 */
class claimState extends UltMeta {
    CLAIMING = new Meta(1, "待处理");
    CLAIMED = new Meta(2, "已完成", THEME_COLOR.Info.intro);
}

export const CLAIM_STATE = new claimState();
